/* eslint-disable quotes */
// components.application.rewards.redeem.viewReward.support

export const REWARD_SUPPORT = {
  title: 'Avertro supports this template',
  description: 'Questions about this template? Just reach out to us and we will get back to you within 2 business days.',
  buttons: { contact: 'CONTACT AVERTRO SUPPORT' }
};
